import React from 'react';
import './Logo.css';

function Logo({ size = 'medium', className = '' }) {
  return (
    <div className={`logo-container ${size} ${className}`}>
      <img 
        src="/logo_sinfondo.png" 
        alt="RTB Collect" 
        className="logo-image"
      />
    </div>
  );
}

export default Logo;
